import { useField } from 'formik'
import React from 'react'
import AppInput from '../ui/AppInput'

interface Props {
  placeholder?: string;
  name: string;
  type?: string;
  label?: string;
}

export default function MyTextInput (props: Props) {
  const [field, meta] = useField(props.name)
  return (
    <AppInput
      {...field}
      {...props}
      error={meta.touched && meta.error}
      sx={{ marginBottom: 12 }}
    />
  )
}
